import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ModulePaths } from '@constants/url.constant';
import { ErrorCode } from '@models/enums/error.codes';
import { SettingsService } from '@services/settings/settings.service';
import { AlertService } from '@services/alert/alert.service';
import { PIN_KEY, USER_PIN_AUTHENTICATED } from '@services/storage/storage.keys.constant';
import { UtilService } from '@services/util/util.service';
import { MsalAuthService } from '@src/msal/msal-auth.service';
import { AppSettingsService } from '@services/app-settings/app-settings.service';
import { NetworkService } from '@services/network/network.service';


export const AuthGuard: CanActivateFn = async (route, state) => {
  const settingsService = inject(SettingsService);
  const appSettingsSvc = inject(AppSettingsService);  
  const networkSvc = inject(NetworkService);  
  const msalAuthService= inject(MsalAuthService)
  const router = inject(Router);
  const utilSvc = inject(UtilService);
  const alertSvc = inject(AlertService);    
  try {


    if(!networkSvc.isOnline) {
      const userPIN = await appSettingsSvc.get<string>(PIN_KEY);
      if(!userPIN) {
        return router.createUrlTree(['/error'], {
          queryParams: {
            message: 'Please set user PIN when online.',
            code: ErrorCode.UserPinNotSet
          }
        });
      }
      const userVerified = await appSettingsSvc.getString(USER_PIN_AUTHENTICATED);
      if(userVerified !== 'true') {
        // Prevent infinite loop: only redirect if not already on verify-pin page
        // if (!state.url.includes('/auth/verify-pin')) {
          return router.createUrlTree([ModulePaths.AUTH + '/verify-pin']);
        // }
        // return false;
      } else {
        // Prevent infinite loop: only redirect if not already on dashboard
        // if (!state.url.includes('/home/dashboard')) {
          return true;
          // await router.navigateByUrl('/home/dashboard');
        // }
        // return false;
      }
    }

    const setData = msalAuthService.getEmpSeq();
    msalAuthService.setAuthData(setData);
    // const seq = msalAuthService.getEmpSeq();   
            // if (seq.seq) {
            //     // Process the auth data
            //     return seq.seq;
            // }
    const response = await settingsService.getUserPin(setData.seq);
    //const localPin = await appSettingsSvc.getString(PIN_KEY, 'false');   
    // Check if we're already on the set-pin page
    const isSetPinPage = state.url.includes('/auth/set-pin');

    // If API returns success and PIN exists
    if (response?.userPin) {
      // Store PIN in local storage if not already stored
      // if (localPin === 'false') {
      await appSettingsSvc.set(PIN_KEY, response.userPin);
      //  }

      // If on set-pin page, redirect to dashboard
      if (isSetPinPage) {
        return router.createUrlTree(['/home/dashboard']);
      }
    } else {
      // If PIN doesn't exist in API or local storage
      await appSettingsSvc.set(PIN_KEY, 'false');
      return router.createUrlTree(['/auth/set-pin']);
    }

    // Allow access to the requested route
    return true;
  } catch (error) {
    console.log(error);
    const errMsg = utilSvc.getErrorMessage(error);
    alertSvc.toast({
      content: errMsg,
      type: {
        style: 'error'
      }
    })
    await appSettingsSvc.set(PIN_KEY, 'false');
    // In your guard or service
    return router.createUrlTree(['/error'], {
      queryParams: {
        message: 'Please contact admin.',
        code: 'PIN_001'
      }
    });
    

  }
};